import Vue from 'vue'
import VueRouter from 'vue-router'
// 以下引入局部路由
import home from './modules/home'
import tech from './modules/tech'
import about from "./modules/about"
import program from "./modules/program"
import contact from "./modules/contact"
import notFound from './modules/notFound'

Vue.use(VueRouter)







const router = new VueRouter({
  routes: [
    home,
      tech,
      about,
      program,
      contact,
    notFound
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


export default router
